















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class BorderNavButton extends Vue {
  @Prop() readonly zone!: string;
  @Prop() readonly border!: string;
  @Prop() readonly alias!: string;
}
